/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OutboundOrderItem } from './OutboundOrderItem';
import {
    OutboundOrderItemFromJSON,
    OutboundOrderItemFromJSONTyped,
    OutboundOrderItemToJSON,
} from './OutboundOrderItem';
import type { OutboundSubOrder } from './OutboundSubOrder';
import {
    OutboundSubOrderFromJSON,
    OutboundSubOrderFromJSONTyped,
    OutboundSubOrderToJSON,
} from './OutboundSubOrder';

/**
 * 
 * @export
 * @interface OutboundOrder
 */
export interface OutboundOrder {
    /**
     * Eindeutige ID des Warenausgangsauftrags
     * @type {string}
     * @memberof OutboundOrder
     */
    id: string;
    /**
     * Auftragsnummer
     * @type {string}
     * @memberof OutboundOrder
     */
    orderNumber: string;
    /**
     * Barcode des Auftrags
     * @type {string}
     * @memberof OutboundOrder
     */
    barcode: string;
    /**
     * Kundenname
     * @type {string}
     * @memberof OutboundOrder
     */
    customer: string;
    /**
     * Kundennummer
     * @type {string}
     * @memberof OutboundOrder
     */
    customerNumber: string;
    /**
     * Auftragsdatum
     * @type {Date}
     * @memberof OutboundOrder
     */
    orderDate: Date;
    /**
     * Gewünschtes Lieferdatum
     * @type {Date}
     * @memberof OutboundOrder
     */
    deliveryDate: Date;
    /**
     * Versandart
     * @type {string}
     * @memberof OutboundOrder
     */
    shippingMethod: string;
    /**
     * Notizen zum Auftrag
     * @type {string}
     * @memberof OutboundOrder
     */
    notes: string;
    /**
     * Liste der Auftragsartikel
     * @type {Array<OutboundOrderItem>}
     * @memberof OutboundOrder
     */
    items: Array<OutboundOrderItem>;
    /**
     * Status des Auftrags
     * @type {string}
     * @memberof OutboundOrder
     */
    status: OutboundOrderStatusEnum;
    /**
     * Gibt an, ob der Auftrag manuell priorisiert wurde
     * @type {boolean}
     * @memberof OutboundOrder
     */
    isManualPriority?: boolean;
    /**
     * Gibt an, ob Teillieferungen erlaubt sind
     * @type {boolean}
     * @memberof OutboundOrder
     */
    hasPartialDelivery?: boolean;
    /**
     * Liste der Teilaufträge
     * @type {Array<OutboundSubOrder>}
     * @memberof OutboundOrder
     */
    subOrders?: Array<OutboundSubOrder>;
}


/**
 * @export
 */
export const OutboundOrderStatusEnum = {
    Open: 'open',
    InProgress: 'in-progress',
    Completed: 'completed',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type OutboundOrderStatusEnum = typeof OutboundOrderStatusEnum[keyof typeof OutboundOrderStatusEnum];


/**
 * Check if a given object implements the OutboundOrder interface.
 */
export function instanceOfOutboundOrder(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "orderNumber" in value;
    isInstance = isInstance && "barcode" in value;
    isInstance = isInstance && "customer" in value;
    isInstance = isInstance && "customerNumber" in value;
    isInstance = isInstance && "orderDate" in value;
    isInstance = isInstance && "deliveryDate" in value;
    isInstance = isInstance && "shippingMethod" in value;
    isInstance = isInstance && "notes" in value;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function OutboundOrderFromJSON(json: any): OutboundOrder {
    return OutboundOrderFromJSONTyped(json, false);
}

export function OutboundOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundOrder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'orderNumber': json['orderNumber'],
        'barcode': json['barcode'],
        'customer': json['customer'],
        'customerNumber': json['customerNumber'],
        'orderDate': (new Date(json['orderDate'])),
        'deliveryDate': (new Date(json['deliveryDate'])),
        'shippingMethod': json['shippingMethod'],
        'notes': json['notes'],
        'items': ((json['items'] as Array<any>).map(OutboundOrderItemFromJSON)),
        'status': json['status'],
        'isManualPriority': !exists(json, 'isManualPriority') ? undefined : json['isManualPriority'],
        'hasPartialDelivery': !exists(json, 'hasPartialDelivery') ? undefined : json['hasPartialDelivery'],
        'subOrders': !exists(json, 'subOrders') ? undefined : ((json['subOrders'] as Array<any>).map(OutboundSubOrderFromJSON)),
    };
}

export function OutboundOrderToJSON(value?: OutboundOrder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'orderNumber': value.orderNumber,
        'barcode': value.barcode,
        'customer': value.customer,
        'customerNumber': value.customerNumber,
        'orderDate': (value.orderDate.toISOString().substr(0,10)),
        'deliveryDate': (value.deliveryDate.toISOString().substr(0,10)),
        'shippingMethod': value.shippingMethod,
        'notes': value.notes,
        'items': ((value.items as Array<any>).map(OutboundOrderItemToJSON)),
        'status': value.status,
        'isManualPriority': value.isManualPriority,
        'hasPartialDelivery': value.hasPartialDelivery,
        'subOrders': value.subOrders === undefined ? undefined : ((value.subOrders as Array<any>).map(OutboundSubOrderToJSON)),
    };
}

